import {useState} from 'react'
import NurseryGroupForm from './NurseryGroupForm';
import NurseryGroupList from './NurseryGroupList';

const NurseryGroup = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <NurseryGroupForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <NurseryGroupList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
        )}
  
    </>
  )
}

export default NurseryGroup